import { clientConfig } from '@/config/clientConfig';
import {
  CurrentMigrationCollectionItem,
  CurrentMigrationCollectionsData,
  MigratedMigrationCollection,
  MigratedMigrationCollectionItem,
  MigratedMigrationCollectionsData,
  SingleCollectionMigrationOption,
  SingleCollectionMigrationProps,
} from '@/shared/lib/sj-orm/migrator';
import { log } from '@/shared/utils/log';

import { ACTUAL_SCHEMA_VERSION } from './migrations';

export const singleCollectionMigration = <
  TCurrentData extends CurrentMigrationCollectionItem = CurrentMigrationCollectionItem,
  TMigratedData extends MigratedMigrationCollectionItem = MigratedMigrationCollectionItem,
>({
  migrateItemFunction,
  collection,
}: SingleCollectionMigrationProps<TCurrentData, TMigratedData>): MigratedMigrationCollection => {
  const collectionData = new Map<string, TMigratedData>();

  collection.forEach((collectionItem, key) => {
    collectionData.set(key, migrateItemFunction(collectionItem));
  });

  return collectionData;
};

export type MigrateCollectionsProps = {
  data: CurrentMigrationCollectionsData;
  migrationOptions: SingleCollectionMigrationOption[];
};

export const migrateCollections = ({ data, migrationOptions }: MigrateCollectionsProps) => {
  const migratedData: MigratedMigrationCollectionsData = new Map();

  migrationOptions.forEach(({ collectionName, migrateItemFunction }) => {
    const collection = data.get(collectionName);

    // TODO rework for checking empty collection
    if (!collection) {
      log.trace(`[migrateCollections]: collection ${collectionName} not found`);
      return;
    }

    const migratedCollection = singleCollectionMigration({ collection, migrateItemFunction });
    migratedData.set(collectionName, migratedCollection);
  });

  return migratedData;
};

export const skipLocalMigrations = () => {
  return (
    clientConfig.devFlags.skipLocalMigrations === true && window.location.hostname === 'localhost'
  );
};

export const isActualVersion = (version: number) => {
  return version === ACTUAL_SCHEMA_VERSION;
};
